<template>
  <div>
    <h4 class="modal__header">
      {{ title }}
      <img
        src="~@/assets/media/icons/close.svg"
        alt="close icon"
        @click="$emit('close')"
      />
    </h4>
    <ProfileForm
      v-show="!showPasswordForm"
      :close="close"
      @close="$emit('close')"
      :togglePasswordForm="togglePasswordForm"
    />
    <PasswordForm
      v-show="showPasswordForm"
      :close="close"
      @close="$emit('close')"
      :togglePasswordForm="togglePasswordForm"
    />
  </div>
</template>

<script>
const ProfileForm = () => import("@/modules/admin/elements/forms/ProfileForm");
const PasswordForm = () =>
  import("@/modules/admin/elements/forms/PasswordForm");

export default {
  name: "AdminProfileEdit",
  components: {
    ProfileForm,
    PasswordForm
  },
  props: {
    close: {
      type: Function,
      default: () => true
    }
  },
  data() {
    return {
      isLoading: false,
      showPasswordForm: false
    };
  },
  methods: {
    togglePasswordForm() {
      this.showPasswordForm = !this.showPasswordForm;
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    title() {
      let title = "Edit Profile";

      if (this.showPasswordForm) title = "Change Password";

      return title;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal__body {
  font-family: "Gotham";
  a {
    font-family: "Gotham";
  }
}
</style>
